import { SupplierAccountWebService } from '@linktivity/gds-neo';
export const ListSupplierAccountsWithPageStatusEnum =
  SupplierAccountWebService.ListSupplierAccountsWithPageStatusEnum;
export type ListSupplierAccountsWithPageStatusEnum =
  SupplierAccountWebService.ListSupplierAccountsWithPageStatusEnum;

export const ListSuppliersStatusEnum =
  SupplierAccountWebService.ListSuppliersWithPageStatusEnum;
export type ListSuppliersStatusEnum =
  SupplierAccountWebService.ListSuppliersWithPageStatusEnum;
